import { HEADER_EVENT_NAME } from "../../header/header";

const NAV_ATTRIB_NAME = "js-account-nav";

export const accountNav = () => {
    const navElement = document.querySelector(`[${NAV_ATTRIB_NAME}]`);

    if (navElement) {
        const navRoot = navElement.getAttribute(NAV_ATTRIB_NAME);
        document.addEventListener(HEADER_EVENT_NAME, (e) => {
            const { detail: {status} } = e;

            const elt = navRoot == "this" ? 
                navElement : 
                navElement.parentElement;

            if (status == "show") {
                elt.classList.add("top--5");
                elt.classList.remove("top--2");
            } else if (status == "hide") {
                elt.classList.add("top--2");
                elt.classList.remove("top--5");
            }
        });
    }
};